module.exports = __webpack_public_path__ + "media/vendors/arrow-ea83531b.png";